export const ApiPath = {
    auth: {
        login: '/auth/login',
        verify:'/auth/verify',
        generate: '/commons/commons/verify-image',
        logout: '/auth/logout',
        refreshToken: '/auth/refreshtoken',
        permissions: '/auth/permissions'
    },
    account: {
        profile: '/shared/get',
    },

    common: {
        base: '/commons',
    },
    setting: {
        base: '/settings',
    },
    shared: {
        base: '/shared',
    },
    uploads: {
        uploadFile: '/files/upload'
    },
}